// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2U9As","search":"Settings_search__28s42","filter":"Settings_filter__6ipEz"};